<template>
  <div class="confirm-stage active">
    <div class="d-title">
      <span class="lbl-cap8 text-bold">Service Selected</span>
      <div class="action-edit" @click="gotoEdit()" v-if="formStore">Edit</div>
    </div>
    <div class="d-detail" v-if="formStore.length > 0">
      <div class="lbl-cap6 text-bold">Tint World<sup>&reg;</sup></div>

      <div class="lbl-cap6" v-for="(service, a) in formStore" :key="a">
        <span>{{ service.category }} - {{ service.name }}, </span>
      </div>

      <div class="lbl-cap6"></div>
    </div>
    <div v-else>
      <p class="error text-danger">You must select a service to continue</p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    formStore() {
      return this.$store.state.user.services;
    },
  },
  methods: {
    gotoEdit: function () {
      return this.$emit("gotoEdit");
    },
  },
};
</script>
